export default "__VITE_ASSET__BytjQTW$__"